module.exports = __webpack_public_path__ + "img/server.957b6ceb.svg";